import React from "react";
import { LOGO_ICON } from "@/content/siteConfig";

type ScreenshotFrameProps = {
  src?: string;
  alt: string;
  label?: string;
  className?: string;
};

export const ScreenshotFrame: React.FC<ScreenshotFrameProps> = ({ src, alt, label, className = "" }) => {
  if (src) {
    const base = src.replace(/\.webp$/, "");
    const srcSet = `${base}-320w.webp 320w, ${base}-640w.webp 640w, ${src} 911w`;
    return (
      <div
        className={`mx-auto w-full max-w-[280px] overflow-hidden rounded-[28px] border border-cvborder bg-cvcard shadow-[0_2px_10px_-2px_rgba(24,25,19,0.08)] ${className}`}
        data-testid="screenshot-frame"
      >
        <img
          src={src}
          srcSet={srcSet}
          sizes="(min-width: 640px) 200px, 280px"
          alt={alt}
          loading="lazy"
          width={280}
          height={615}
          className="block h-auto w-full"
        />
      </div>
    );
  }

  return (
    <div
      className={`relative mx-auto aspect-[9/18.5] w-full max-w-[280px] overflow-hidden rounded-[28px] border border-cvborder bg-cvcard shadow-[0_2px_10px_-2px_rgba(24,25,19,0.08)] ${className}`}
      data-testid="screenshot-frame"
    >
      <div className="flex h-full w-full flex-col items-center justify-center gap-3 px-6 text-center">
        <img src={LOGO_ICON} alt="" className="h-10 w-10 rounded-[10px] opacity-30" />
        <p className="text-sm text-cvmuted">{label || "Screenshot to be added"}</p>
      </div>
    </div>
  );
};
